import { useNavigate } from 'react-router-dom';

interface DashboardHeaderProps {
  deviceId: string;
}

export default function DashboardHeader({ deviceId }: DashboardHeaderProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('device_id');
    navigate('/');
  };

  return (
    <header
      className="w-full sticky top-0 z-40 shadow-sm"
      style={{ background: 'linear-gradient(90deg, #1B4F72 0%, #145a32 100%)' }}
    >
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 h-14 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg overflow-hidden bg-white/15">
            <img
              src="https://public.readdy.ai/ai/img_res/9afcb98f-92d6-44dd-b7d6-8d5092554fc9.png"
              alt="Logo"
              className="w-6 h-6 object-contain"
            />
          </div>
          <div>
            <h1 className="text-white font-bold text-sm md:text-base leading-tight">
              벼 작황 모니터링
            </h1>
            <p className="text-green-300 text-xs leading-tight hidden sm:block">
              Device: <span className="font-semibold text-white">{deviceId}</span>
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <span className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/10 text-white text-xs">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-cpu-line"></i>
            </div>
            {deviceId}
          </span>
          <button
            onClick={handleLogout}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-white text-xs font-medium cursor-pointer whitespace-nowrap transition-all hover:bg-white/20 border border-white/30"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-logout-box-line"></i>
            </div>
            로그아웃
          </button>
        </div>
      </div>
    </header>
  );
}